import {
    CREATE_ANSWER,
    CREATE_ANSWER_SUCCESS,
    UPDATE_ANSWER,
    UPDATE_ANSWER_SUCCESS,
    DELETE_ANSWER,
    DELETE_ANSWER_SUCCESS,
    BIND_TYPE_TO_ANSWER,
    BIND_TYPE_TO_ANSWER_SUCCESS
} from './constants';

/**
 *
 * @param questionID
 * @param answer
 * @param localizationId
 * @param questionType
 * @param resolve
 * @returns {{questionID: *, answer: *, resolve: *, localizationId: *, type: string, questionType: *}}
 */
const createAnswer = (questionID, answer, localizationId, questionType,  resolve) => ({
    type: CREATE_ANSWER,
    questionID,
    answer,
    localizationId,
    questionType,
    resolve
});
/**
 *
 * @param questionID
 * @param question
 * @returns {{questionID: *, question: *, type: string}}
 */
const createAnswerSuccess = (questionID, question) => ({
    type: CREATE_ANSWER_SUCCESS,
    questionID,
    question
});
/**
 *
 * @param questionID
 * @param answerId
 * @param answer
 * @param questionType
 * @param resolve
 * @returns {{answerId: *, questionID: *, answer: *, resolve: *, type: string, questionType: *}}
 */
const updateAnswer = (questionID, answerId, answer, questionType, resolve) => ({
    type: UPDATE_ANSWER,
    questionID,
    answerId,
    answer,
    questionType,
    resolve
});
/**
 *
 * @param bindObjectId
 * @param typeId
 * @param answerId
 * @param answerType
 * @param points
 * @returns {{bindObjectId: *, answerId: *, answerType: *, typeId: *, type: string, points: *}}
 */
const bindTypeToAnswer = ({bindObjectId,typeId,answerId,answerType,points})=> ({
    type: BIND_TYPE_TO_ANSWER,
    bindObjectId,
    typeId,
    answerId,
    answerType,
    points
});

/**
 *
 * @param questionID
 * @param question
 * @param answerId
 * @returns {{answerId: *, questionID: *, question: *, type: string}}
 */
const updateAnswerSuccess = (questionID, question, answerId) => ({
    type: UPDATE_ANSWER_SUCCESS,
    questionID,
    question,
    answerId
});
/**
 *
 * @param questionID
 * @param answerId
 * @param questionType
 * @param resolve
 * @returns {{answerId: *, questionID: *, resolve: *, type: string, questionType: *}}
 */
const deleteAnswer = (questionID, answerId, questionType, resolve) => ({
    type: DELETE_ANSWER,
    questionID,
    answerId,
    questionType,
    resolve
});
/**
 *
 * @param questionID
 * @param question
 * @returns {{questionID: *, question: *, type: string}}
 */
const deleteAnswerSuccess = (questionID, question) => ({
    type: DELETE_ANSWER_SUCCESS,
    questionID,
    question
});
/**
 *
 * @param updatedQuestion
 * @returns {{questionID, question: *, type: string}}
 */
const bindTypeToAnswerSuccess = (updatedQuestion) => ({
    type: BIND_TYPE_TO_ANSWER_SUCCESS,
    questionID: updatedQuestion.question_id,
    question: updatedQuestion
});

export {
    createAnswer,
    createAnswerSuccess,
    updateAnswer,
    updateAnswerSuccess,
    deleteAnswer,
    deleteAnswerSuccess,
    bindTypeToAnswer,
    bindTypeToAnswerSuccess
};